module.exports = __webpack_public_path__ + "img/default_room.d1fd2b1a.png";